/* eslint-disable react/no-danger */

import React from "react";
import PropTypes from "prop-types";

import DateFormatingService from "services/DateFormatingService";

const TimelineItem = ({ item }) => (
  <div className="timeline-item">
    <div className="timeline-item__time">
      {DateFormatingService.formatToTimeLineItemDate(item.created * 1000)}
    </div>
    <div
      className="timeline-item__teaser"
      dangerouslySetInnerHTML={{ __html: item.html }}
    />
  </div>
);

TimelineItem.propTypes = {
  item: PropTypes.shape({
    created: PropTypes.string.isRequired,
    html: PropTypes.string.isRequired,
  }).isRequired,
};

export default TimelineItem;
